import {action, observable, computed} from 'mobx'
import React from 'react'
import {PricesType, GroupType, DeviceType} from '@/types/NewMachineTypes'
import PayType from '@/types/PayType'
import {IdType} from '@/types/IdTypes'
import {Icon, Modal} from "antd";
import stores from "@/stores";

type API = (params: object) => Promise<any>

class Service {

  getPricesAPI: API
  getGroupListAPI: API
  getDeviceListAPI: API
  deviceBuyAPI: API
  productId: number
  roomId: number

  @computed get pricesParams(): object {
    return {}
  }

  @computed get buyParams(): object {
    return {}
  }

  @observable prices: (PricesType)[] = [] // 价格列表
  @observable selectPrice: PricesType | undefined // 选择的价格信息

  @observable.ref groupList: (GroupType)[] = [] // 分组列表
  @observable groupId: IdType = '' // 选择的分组ID
  @observable deviceList: (DeviceType)[] = [] // 设备列表
  @observable payType: PayType = 1 // 支付方式
  @observable selectedIds: number[] = []// 选中的id的数组

  @observable allDeviceId: number[] = [] //设备id

  // 半选中状态
  @computed get indeterminate(): boolean {
    const len = this.selectedIds.length
    return len ? len < this.allDeviceId.length : false
  }

  // 选择的价格id
  @computed get priceId(): number|null {
    return (this.selectPrice && this.selectPrice.id) || null
  }

  @computed get price(): number {
    return (this.selectPrice && this.selectPrice.real_price) || 0
  }


  @computed get totalPrice(): string {
    return ((this.price * this.selectedIds.length) / 100).toFixed(2)
  }

  @computed get allSelectStaut(): boolean {
    return this.selectedIds.length === this.allDeviceId.length ? true : false
  }

  // 计算设备列数
  @computed get deviceCol(): number {
    return this.deviceList.length ? (this.deviceList.length < 3 ? this.deviceList.length : 3) : 1
  }

  // 初始化
  @action.bound
  async init() {
    // 初始化数据
    this.prices = [] // 价格列表
    this.groupList = [] // 分组列表
    this.groupId = '' // 选择的分组ID
    this.deviceList = [] // 设备列表
    this.payType = 1 // 支付方式
    this.selectedIds = []// 选中的id的数组
    this.allDeviceId = [] //设备id
    this.selectPrice = Object.create(null)

    this.getPrices()
    this.getGroupList()
  }

  // 获取价格列表
  @action.bound
  async getPrices() {
    const [error, rustlt] = await this.getPricesAPI(this.pricesParams)
    if (error) return;
    this.prices = rustlt.priceList
  }

  // 修改价格
  @action.bound
  async changePriceId(price: PricesType) {
    this.selectPrice = price
  }

  // 修改支付方式
  @action.bound
  async togglePayType(type: PayType) {
    this.payType = type
  }

  // 获取分组列表
  @action.bound
  async getGroupList() {
    let params = {
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id
    }
    const [error, result] = await this.getGroupListAPI(params)
    if (error) return;
    this.groupList = result.groupList || []
    console.log(this.groupList)
    if (this.groupList.length) {
      this.groupId = this.groupList[0].id
      this.getDeviceList()
    }
  }

  // 获取设备列表
  @action.bound
  async getDeviceList() {
    let params = {
      groupId: this.groupId,
      productId: this.productId
    }
    const [error, result] = await this.getDeviceListAPI(params)
    if (error) return;
    this.deviceList = result.group_device_list
    this.allDeviceId = result.group_device_list.map((item: DeviceType) => item.id)
  }

  // 修改分组
  @action.bound
  async changeGroupId(id: IdType) {
    if (this.groupId === id) return;
    this.groupId = id

    // 清空选择的数据
    this.deviceList = [];
    this.selectedIds = [];
    this.allDeviceId = [];

    // 获取设备列表
    this.getDeviceList()

  }

  // 修改设备状态
  @action.bound
  toggleDevice(list: []) {
    this.selectedIds = list
  }

  // 生成订单
  @action.bound
  async deviceBuy() {

    const [error, result] = await this.deviceBuyAPI(this.buyParams)
    if (error) return;
    Modal.confirm({
      content: '支付订单已提交',
      cancelText: '已完成支付',
      okText: '支付遇到问题',
      icon: <Icon type='check-circle' style={{color:'#5AD36F'}} />,
    onCancel () {
      stores.routingStore.history.push('/Home/Order')
    },
    onOk() {
      stores.routingStore.history.push('/Home/Order')
    }
  })
    if (result.request_url) {
      if (this.payType === 1) {
        window.open(result.request_url)
        return;
      }
      // 微信支付
      window.open(`/WeixinPay/${this.totalPrice}/${result.order_id}/${encodeURIComponent(result.request_url)}`)
    }
  }

// 修改全选状态
  @action.bound
  async toggleAllSelected(bool: boolean) {
    console.log('allDeviceId', this.allDeviceId.slice())
    this.selectedIds = bool ? this.allDeviceId : []
  }

}

export default Service


